<template>
  <div class="w-full">
    <cardTitle title="安防设备在线率" cardType='shimen' />
    <div class="w-full flex justify-between h-[calc(100%-56px)] p-t-4px">
      <div
        class="gauge_item"
        v-for="(item, index) in gaugeList"
        :key="index"
        @click="gaugeClick(item)"
      >
        <div
          class="gauge_item_title"
          :style="{
            backgroundColor:
              index == 1 ? 'rgba(89,94,212,0.56)' : index == 2 ? 'rgba(195,171,108,0.5)' : '',
          }"
        >
          {{ item.title }}
        </div>
        <div class="gauge_item_main">
          <div class="total">
            <span style="opacity: 0.7">总数</span>
            <span style="font-size: 16px; color: #fff">{{ item.TotalCount }}</span>
          </div>
          <div class="echarts_box">
            <Gauge height="100px" width="76" :value="item.OnlinePercent"></Gauge>
          </div>
          <div class="data">
            <div class="dataItem">
              <span class="dataItem_online">在线</span>
              <span>{{ item.OnlineCount }}</span>
            </div>
            <div class="dataItem">
              <span class="dataItem_outline">离线</span>
              <span>{{ item.OfflineCount }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <DeviceDialog  v-if="openDeviceDialog"
      @closeDig="closeDeviceDialog"
      :defenseDigProps="deviceDialogProps"></DeviceDialog>
  </div>
</template>

<script>
import CardTitle from '@/components/cockpit/CardTitle'
import Gauge from '../charts/Gauge.vue'
import CockpitService from '../../service/index'
import DeviceDialog from '../DeviceDialog.vue'

export default {
  name: 'SecurityCard',
  props: [],
  components: { CardTitle, Gauge, DeviceDialog },
  data() {
    return {
      initInterval: null,
      gaugeList: [
        {
          title: '监控设备',
          key: 'monitor',
          TotalCount: 0,
          OnlinePercent: 0,
          OnlineCount: 0,
          OfflineCount: 0,
        },
        {
          title: '门禁设备',
          key: 'doorDevice',
          TotalCount: 0,
          OnlinePercent: 0,
          OnlineCount: 0,
          OfflineCount: 0,
        },
        {
          title: '车辆道闸',
          key: 'carDevice',
          TotalCount: 0,
          OnlinePercent: 0,
          OnlineCount: 0,
          OfflineCount: 0,
        },
      ],
      deviceDialogProps: {
        title: '',
      },
      openDeviceDialog: false,
    }
  },
  methods: {
    // 安防设备在线率
    async getDeviceStatistic() {
      const [err, res] = await CockpitService.getDeviceStatistic()
      console.log(res, '3$%%#%#$%#$3')

      if (res && res.code === '0' && res.data) {
        _.forEach(this.gaugeList, (item) => {
          this.$set(item, 'TotalCount', res.data[`${item.key}TotalCount`])
          this.$set(item, 'OnlinePercent', res.data[`${item.key}OnlinePercent`])
          this.$set(item, 'OnlineCount', res.data[`${item.key}OnlineCount`])
          this.$set(item, 'OfflineCount', res.data[`${item.key}OfflineCount`])
        })
      }
    },
    closeDeviceDialog() {
      this.openDeviceDialog = false
    },
    gaugeClick(item) {
      this.deviceDialogProps.title = item.title
      this.openDeviceDialog = true
    },
  },
  beforeDestroy() {
    clearInterval(this.initInterval)
  },

  mounted() {
    this.getDeviceStatistic()
    this.initInterval = setInterval(() => {
      this.getDeviceStatistic()
    }, 5000)
  },
}
</script>

<style lang="scss" scoped>
.gauge {
  .dig_cont {
    position: absolute;
    width: 700px;
    height: 420px;
    z-index: 999;
    top: 27%;
    left: 110%;
  }
  position: relative;
  height: calc(100% - 50px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
  &_item {
    width: 32%;
    display: flex;
    flex-direction: column;
    &_title {
      height: 30px;
      color: #fff;
      font-size: 15px;
      text-align: center;
      background-color: rgba(83, 162, 255, 0.4);
      line-height: 30px;
    }
    &_main {
      border: 1px dashed rgba(255, 255, 255, 0.1);
      padding: 6px;
      .total {
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        color: #fff;
        line-height: 20px;
        background: rgba(217, 217, 217, 0.12);
        padding: 4px 10px;
      }

      .echarts_box {
        width: 100%;
        height: 100px;
        .bottom_text {
          position: relative;
          font-size: 12px;
          text-align: center;
          color: rgba(255, 255, 255, 0.7);
        }
      }
      .data {
        display: flex;
        flex-direction: column;
        .dataItem {
          color: #fff;
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          line-height: 20px;
          padding: 0 8px;
          margin-bottom: 4px;
          .dataItem_online {
            font-size: 12px;
            color: rgba(255, 255, 255, 0.7);
          }
          .dataItem_online::before {
            content: '';
            display: inline-block;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background-color: #0da537;
            margin-right: 7px;
          }
          .dataItem_outline {
            font-size: 12px;
            color: rgba(255, 255, 255, 0.7);
          }
          .dataItem_outline::before {
            content: '';
            display: inline-block;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background-color: #94a8d9;
            margin-right: 7px;
          }
        }
      }
    }
  }
}
.gauge_item {
  height: 100%;
  cursor: pointer;
}
.gauge_item_main {
  height: calc(100% - 30px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
